<template>
  <th
    class="tab-element sticky action"
    :class="{ right: side === 'right', left: side === 'left', tiny: tiny }"
    style="background-color: rgb(246, 246, 252)"
  >
    <slot></slot>
  </th>
</template>

<script>
export default {
  name: 'table-header-action',

  props: {
    side: {
      type: String,
      default: 'right',
    },
    tiny: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped></style>
